import graphqlClient from "../../../apollo";

class CouponProvider {

    findCoupon(id) {
        return graphqlClient.query({
            query: require('./gql/Coupon/findCoupon.graphql'),
            variables: {id:id},
            fetchPolicy: "network-only"
        })
    }

    findCouponByCode(code) {
        return graphqlClient.query({
            query: require('./gql/Coupon/findCouponByCode.graphql'),
            variables: {code},
            fetchPolicy: "network-only"
        })
    }

    fetchCoupon() {
        return graphqlClient.query({
        query: require('./gql/Coupon/fetchCoupon.graphql'),
        fetchPolicy: "network-only"
        })
    }

    paginateCoupon(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Coupon/paginateCoupon.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createCoupon(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Coupon/createCoupon.graphql'),
            variables: {input}
        })
    }

    updateCoupon(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Coupon/updateCoupon.graphql'),
            variables: {id, input}
        })
    }

     deleteCoupon(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Coupon/deleteCoupon.graphql'),
            variables: {id}
        })
    }

}

export default new CouponProvider()


